<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl ? `master/center/${inputs.id}` : `master/center`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_last_modified" class="col-sm-3 mb-0">
						Last Modified
					</label>
					<app-input
						id="inputs_last_modified"
						class="col-sm-9"
						type="date"
						v-model="inputs.updated_at"
						placeholder="Last Modified"
						:disabled="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_by" class="col-sm-3 mb-0"> By </label>
					<app-input
						id="inputs_by"
						class="col-sm-9"
						type="advance-search-select"
						fetch-url="user-list"
						:loaded-per-time="10"
						v-model="input_by_id"
						@input="setByIdValue"
						list-value-field="full_name"
						placeholder="Name"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_comment" class="col-sm-3 mb-0">
						Comment
					</label>
					<app-input
						id="inputs_comment"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.comment"
						placeholder="Comment"
					/>
				</div>

				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";

export default {
	name: "StudyDetailsForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				name: "",
			},
			modalId: this.formId,
			modalTitle: this.$t("add"),
			input_by_id: this.value
				? this.value
					? {
							id: this.value.id || 0,
							full_name: this.value.full_name || "",
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							full_name: this.value?.full_name || "",
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						full_name: this.value.full_name || "",
						is_active: this.value.is_active,
				  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},

		setByIdValue(data) {
			this.inputs.by_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.by_id = data.id;
			}
		},
	},
};
</script>
